import axios from 'axios';
import AxiosConfiguration from '@/classes/AxiosConfiguration';
import {
  DocumentReferencesResultModel,
  ReferenceLookupResultModel,
  ReferenceLookupSearchModel
} from '@/types';

const ReferenceLookupApiUrl = 'ReferenceLookup';

export const ReferenceLookupService = {
  async getSpecialLookupReferencesAsync(
    documentTypeId: number,
    searchModel: ReferenceLookupSearchModel
  ): Promise<ReferenceLookupResultModel> {
    const response = await axios.post(`${ReferenceLookupApiUrl}/${documentTypeId}`, searchModel);
    return response.data;
  },
  async getDocumentsByReferences(
    cabinetId: string,
    documentTypeId: number,
    referenceLookupSearchModel: ReferenceLookupSearchModel
  ): Promise<DocumentReferencesResultModel> {

    function removeTimePortion(value: string): string {
      const index = value.lastIndexOf(' 00:00:00');
      if (index >= 0) {
        return value.substring(0, index);
      }
      return value;
    }

    Object.keys(referenceLookupSearchModel.references).forEach((key: string) => {
      referenceLookupSearchModel.references[key] = removeTimePortion(referenceLookupSearchModel.references[key]);
    });

    const url = [ReferenceLookupApiUrl, cabinetId, documentTypeId, 'documents'].join('/');
    const response = await AxiosConfiguration.axiosWithErrorPage.post(url, referenceLookupSearchModel);

    return response.data;
  }
};
